export default {
  saveFileError: 'ファイルの保存(binファイルまたはmapファイル)に失敗しました',
  replaceResourcesError: 'リソースの置換に失敗しました',
  uuid2UrlError: 'uuid2urlが空です',
  assetTypeError: '現在選択されている画像タイプはASSET_ATLASではありません',
}
